export default __webpack_public_path__ + "static/media/congrats-completed.5c8e498a.gif";